import { render, staticRenderFns } from "./DashboardVendor.vue?vue&type=template&id=0d620a6e"
import script from "./DashboardVendor.vue?vue&type=script&lang=js"
export * from "./DashboardVendor.vue?vue&type=script&lang=js"
import style0 from "./DashboardVendor.vue?vue&type=style&index=0&id=0d620a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports